import { useStores } from './useStores'

export function useData() {
  const { traversal } = useStores()

  return { data: traversal.data }
}
